import CM1 from "./assets/images/CM/CM1.jpg"
import CM2 from "./assets/images/CM/CM2.jpg"
import CM3 from "./assets/images/CM/CM3.jpg"
import CM4 from "./assets/images/CM/CM4.jpg"
import CM5 from "./assets/images/CM/CM5.jpg"

import VEUILLEZ1 from "./assets/images/VEUILLEZ/VEUILLEZ1.jpg"
import VEUILLEZ2 from "./assets/images/VEUILLEZ/VEUILLEZ2.jpg"
import VEUILLEZ3 from "./assets/images/VEUILLEZ/VEUILLEZ3.jpg"
import VEUILLEZ4 from "./assets/images/VEUILLEZ/VEUILLEZ4.jpg"

import UR1 from "./assets/images/U&R/U&R.jpg"
import UR2 from "./assets/images/U&R/U&R2.jpg"
import UR3 from "./assets/images/U&R/U&R3.jpg"
import UR4 from "./assets/images/U&R/U&R4.jpg"
import UR5 from "./assets/images/U&R/U&R5.jpg"
import UR6 from "./assets/images/U&R/U&R6.jpg"
import UR7 from "./assets/images/U&R/U&R7.jpg"

import DD1 from "./assets/images/DATADRAMA/DATADRAMA_1.jpg"
import DD2 from "./assets/images/DATADRAMA/DATADRAMA_2.jpg"
import DD3 from "./assets/images/DATADRAMA/DATADRAMA_3.jpg"
import DD4 from "./assets/images/DATADRAMA/DATADRAMA_4.jpg"

// import FIF1 from "./assets/images/FIF/FIF85.jpg"
// import FIF2 from "./assets/images/FIF/FIF852.jpg"
// import FIF3 from "./assets/images/FIF/FIF853.jpg"
// import FIF4 from "./assets/images/FIF/FIF854.jpg"
// import FIF5 from "./assets/images/FIF/FIF855.jpg"

import LAC1 from "./assets/images/LAC/LAC1.jpg"
import LAC2 from "./assets/images/LAC/LAC2.jpg"
import LAC3 from "./assets/images/LAC/LAC3.jpg"
import LAC4 from "./assets/images/LAC/LAC4.jpg"

// import TFC1 from "./assets/images/TFC/TFC1_GENERIQUE_1.mp4"
// import TFC2 from "./assets/images/TFC/TFC2.jpg"
// import TFC3 from "./assets/images/TFC/TFC3_BIRTH_1.mp4"
// import TFC4 from "./assets/images/TFC/TFC4.jpg"
// import TFC5 from "./assets/images/TFC/TFC5_ROCKET_1.mp4"
// import TFC6 from "./assets/images/TFC/TFC6.jpg"

// import KONBINI01 from "./assets/images/KONBINI/KONBINI01.jpg"
// import KONBINI02 from "./assets/images/KONBINI/KONBINI02_1.mp4"
// import KONBINI03 from "./assets/images/KONBINI/KONBINI03_1.mp4"
// import KONBINI04 from "./assets/images/KONBINI/KONBINI04_1.mp4"


import RICHEMONT1 from "./assets/images/RICHEMONT/RICHEMONT.jpg"
import RICHEMONT2 from "./assets/images/RICHEMONT/RICHEMONT2.jpg"
import RICHEMONT3 from "./assets/images/RICHEMONT/RICHEMONT3.jpg"
import RICHEMONT4 from "./assets/images/RICHEMONT/RICHEMONT4.jpg"
import RICHEMONT5 from "./assets/images/RICHEMONT/RICHEMONT5.jpg"

// import PODCASTS1 from "./assets/images/PODCASTS/PODCASTS1.jpg"
// import PODCASTS2 from "./assets/images/PODCASTS/PODCASTS2.jpg"
// import PODCASTS3 from "./assets/images/PODCASTS/PODCASTS3.jpg"
// import PODCASTS4 from "./assets/images/PODCASTS/PODCASTS4.jpg"

import JOSIE1 from "./assets/images/JOSIE/JOSIE1.jpg"
import JOSIE2 from "./assets/images/JOSIE/JOSIE2.jpg"
import JOSIE3 from "./assets/images/JOSIE/JOSIE3.jpg"
import JOSIE4 from "./assets/images/JOSIE/JOSIE4.jpg"
import JOSIE5 from "./assets/images/JOSIE/JOSIE5.jpg"

import TRIBAM1 from "./assets/images/TRIBAM/TRIBAM1.jpg"
import TRIBAM2 from "./assets/images/TRIBAM/TRIBAM2.jpg"
import TRIBAM3 from "./assets/images/TRIBAM/TRIBAM3.jpg"

import CREOLE1 from "./assets/images/CREOLE/CREOLE1.jpg"
import CREOLE2 from "./assets/images/CREOLE/CREOLE2.jpg"

import LMF1 from "./assets/images/LMF/LMF1.jpg"
import LMF2 from "./assets/images/LMF/LMF2.jpg"
import LMF3 from "./assets/images/LMF/LMF3.jpg"
import LMF4 from "./assets/images/LMF/LMF4.jpg"
import LMF5 from "./assets/images/LMF/LMF5.jpg"
import LMF6 from "./assets/images/LMF/LMF6.jpg"

import NETFLIX1 from "./assets/images/NETFLIX/NETFLIX1.jpg"
import NETFLIX2 from "./assets/images/NETFLIX/NETFLIX2.jpg"
import NETFLIX3 from "./assets/images/NETFLIX/NETFLIX3.jpg"
import NETFLIX4 from "./assets/images/NETFLIX/NETFLIX4.jpg"
import NETFLIX5 from "./assets/images/NETFLIX/NETFLIX5.jpg"

import WA1 from "./assets/images/WA/WA1.jpg"
import WA2 from "./assets/images/WA/WA2.jpg"
import WA3 from "./assets/images/WA/WA3.jpg"
import WA4 from "./assets/images/WA/WA4.jpg"


// const KONBINI_YOUTUBE_ID = "oeAAKnn0GPw"
const STANDUP_YOUTUBE_ID = "Zb7fvCTFf6A"
const IDEEFORTE_YOUTUBE_ID = "7xgFWtjtKCQ"
const TFC_YOUTUBE_ID = "WQ5L6ANQBuI"



export const projectList = [
  {
    title: "Outremer La Première",
    resume: "podcast visual identity",
    img: [CREOLE1, CREOLE2],
  },
  {
    title: "La Maison forte, cahiers n°2+3 ",
    resume: "editorial",
    img: [LMF1, LMF2, LMF3, LMF4, LMF5, LMF6],
  },
  {
    title: "Netflix + OpenAsso",
    resume: "AD, editorial",
    img: [NETFLIX1, NETFLIX2, NETFLIX3, NETFLIX4, NETFLIX5],
  },
  {
    title: "Wise Ancestors",
    resume: "brand identity",
    link: "https://www.wiseancestors.org/",
    img: [WA1, WA2, WA3, WA4],
  },
  {
    title: "La Maison forte, cahier n°1",
    resume: "Editorial",
    img: [CM1, CM2, CM3, CM4, CM5],
  },
  {
    title: "Night scroll",
    resume: "illustration, self-publishing",
    img: [VEUILLEZ1, VEUILLEZ2, VEUILLEZ3, VEUILLEZ4],
  },
  {
    title: "L’ADN video content",
    resume: "motion design",
    link: "https://www.instagram.com/ladneu/reels/",
    img: [STANDUP_YOUTUBE_ID],
  },
  {
    title: "L’ADN video content",
    resume: "motion design",
    link: "https://www.instagram.com/ladneu/reels/",
    img: [IDEEFORTE_YOUTUBE_ID],
  },
  {
    title: "Usbek & Rica",
    resume: "AD, editorial",
    img: [UR1, UR2, UR3, UR4, UR5, UR6, UR7],
  },
  {
    title: "DATADRAMA",
    resume: "illustration, self-publishing",
    img: [DD1, DD2, DD3, DD4],
  },
  // {
  //   title: "F.I.F.85",
  //   resume: "Proposition d’identité pour le festival yonnais dédié au cinéma international.",
  //   img: [FIF1, FIF2, FIF3, FIF4, FIF5],
  // },
  {
    title: "ArianeGroup",
    resume: "AD, motion design",
    link: "https://www.facebook.com/watch/live/?v=539265316926153&ref=watch_permalink",
    img: [
      TFC_YOUTUBE_ID
    ],
  },
  {
    title: "L’Autre Canal (Nancy)",
    resume: "illustration, AD, editorial",
    img: [LAC1, LAC2, LAC3, LAC4],
  },
  // {
  //   title: "Podcasts",
  //   resume: "5 émissions sur le futur par Usbek & Rica.",
  //   img: [PODCASTS1, PODCASTS2, PODCASTS3, PODCASTS4],
  // },
  {
    title: "Trinitaires / BAM (Metz)",
    resume: "AD, editorial",
    img: [TRIBAM1, TRIBAM2, TRIBAM3],
  },
  {
    title: "Xiu Xiu, ‘Josie’s Past’",
    resume: "direction, animation",
    link: "https://www.youtube.com/watch?v=8A4FxKXL5pk&t=205s",
    img: [JOSIE1, JOSIE2, JOSIE3, JOSIE4, JOSIE5],
  },
  {
    title: "Richemont",
    resume: "AD, editorial",
    img: [RICHEMONT1, RICHEMONT2, RICHEMONT3, RICHEMONT4, RICHEMONT5],
  },
  // {
  //   title: "Les néobanques",
  //   resume: "Vidéo explicative (explainer) retraçant l’histoire des néobanques, pour Konbini x N26.",
  //   link: "Voir la vidéo.",
  //   url: "https://www.facebook.com/konbinifr/videos/512529209883788/?app=fbl",
  //   img: [
  //     KONBINI_YOUTUBE_ID
  //   ],
  // },
]
